module.exports = __webpack_public_path__ + "img/6bfc4eb61f0b4ce7ac1f86e080765ea3-1024.486da190.jpg";